import React from "react";
import { ImCancelCircle } from "react-icons/im";
import '../../../Styles/userProfile.css'

const AdminPermission = ({ openModal }: any) => {
  return (
    <div className="modal">
      <div className="permissionModal">
        <div className="catModalTop">
          <h4>Admin Permission</h4>
          <ImCancelCircle className="catCancel" onClick={openModal}/>
        </div>
        <div className="line"></div>

        <div className="permision">
          <p>Make Requisition</p>
          <p>Approve Requisition</p>
          <p>Add Product</p>
          <p>Fund Customers Wallet</p>
          <p>Approve Purchase /Number of Liter</p>
          <p>Delete Information</p>
          <p>View All Report</p>
          <p>Generate Loading Slip</p>
        </div>

        <div className="catModalBtn">
          <button className="catBtn2" onClick={openModal}>Back</button>
        </div>
      </div>
    </div>
  );
};

export default AdminPermission;
